import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Layout, Tabs, Typography } from 'antd'
import { KeyOutlined, FileTextOutlined } from '@ant-design/icons'

import { DefaultLayout } from 'src/layouts/default'
import { Gap } from 'src/components/atoms/Gap'
import { ApiKeyManagement } from './ApiKeyManagement'
import { ApiDocumentation } from './ApiDocumentation'

const { Content } = Layout
const { TabPane } = Tabs
const { Title, Paragraph } = Typography

export const _Developer = ({ token }) => {
  const [activeTab, setActiveTab] = useState('1')

  return (
    <DefaultLayout>
      <Gap height='1rem' />
      <Layout className='container-dashboard'>
        <Content className='container'>
          <Title level={2}>Developer Center</Title>
          <Paragraph>
            Kelola API keys dan akses dokumentasi API untuk integrasi dengan
            sistem OPIM.
          </Paragraph>

          <Tabs activeKey={activeTab} onChange={setActiveTab}>
            <TabPane
              tab={
                <span>
                  <KeyOutlined />
                  API Keys
                </span>
              }
              key='1'
            >
              <ApiKeyManagement token={token} />
            </TabPane>

            <TabPane
              tab={
                <span>
                  <FileTextOutlined />
                  API Documentation
                </span>
              }
              key='2'
            >
              <ApiDocumentation token={token} />
            </TabPane>
          </Tabs>
        </Content>
      </Layout>
    </DefaultLayout>
  )
}

export const Developer = _Developer

_Developer.propTypes = {
  token: PropTypes.string
}
